import React from 'react';
import { useTranslation } from 'react-i18next';

import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';
import DeleteButton from 'components/DeleteButton';

import DialogCloseIcon from './style';

export interface IConfirmationProps {
	open: boolean;
	resolve: () => void;
	reject: () => void;
	title?: string;
	text?: string;
}

function Confirmation({ open = false, resolve, reject, title, text }: IConfirmationProps) {
	const { t } = useTranslation();
	return (
		<Dialog open={open} PaperProps={{ sx: { maxWidth: '500px' } }} onClose={reject}>
			<DialogCloseIcon onClick={() => reject()} color="primary" background size="large" />
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					marginBottom: '10px',
				}}
			>
				<DeleteButton size="large" />
			</Box>
			<DialogContent
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					gap: '4px',
				}}
			>
				<DialogTitle sx={{ padding: 0 }}>{title || t('shared.areYouSure')}</DialogTitle>
				<DialogContentText sx={{ letterSpacing: '0.15px', textAlign: 'center' }}>
					{text || t('shared.youWantToDelete')}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={() => reject()}>
					{t('shared.cancel')}
				</Button>
				<Button onClick={() => resolve()} variant="contained" color="error">
					{t('shared.delete')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default Confirmation;
